import React from "react";
import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import "./NotFoundPage.css";
import { RouteComponentProps } from "react-router";
import { useTranslation } from "react-i18next";
interface Props extends RouteComponentProps {
  pageName: string;
}
const NotFoundPage: React.FC<Props> = ({
  pageName
}) => {
  const {
    t
  } = useTranslation();
  return <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>{pageName}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">{pageName}</IonTitle>
          </IonToolbar>
        </IonHeader>
        <span>{t("NotFound")}</span>
      </IonContent>
    </IonPage>;
};
export default NotFoundPage;